import { memo } from "react";

import { TableItemId } from "../../../../../components/tables/TableWidget";
import ActionMenu from "../../../../../components/actionMenu/ActionMenu";

import { TableItemType } from "../../../../../components/tables/tableContext/TableContext";
import { expeditionRoutes } from "../../../../../router/routesConstants";
import { useNavigate } from "react-router-dom";
import { ClientWorkingPointsDataInterface } from "../../../../../redux/interfaces/general.interface";

function ExpeditionScheduleWorkingPointsTableActionButtons({
  itemId,
  crudData,
}: {
  itemId: TableItemId;
  tableItemData: TableItemType[];
  crudData?: ClientWorkingPointsDataInterface;
  tableContext?: any;
}) {
  const navigate = useNavigate();

  const goToOrganizeWorkingPoint = () => {
    navigate(
      `/${expeditionRoutes.clientWorkingPoints}/${expeditionRoutes.organize}?id=${itemId}&routeId=${crudData?.idPctLucru}`,
    );
  };

  return (
    <ActionMenu
      minItemsForMenu={2}
      title={crudData?.pctDeLivrare}
      ariaLabel={`Actiuni pentru punctul de lucru ${
        crudData?.pctDeLivrare ?? ""
      }`}
      items={[
        {
          id: "organize-working-point",
          label: "Organizare",
          icon: "DOCUMENT_WITH_DOWNLOAD",
          tooltip:
            "Deschide formularul de editare a punctului de lucru.",
          onClick: goToOrganizeWorkingPoint,
        },
      ]}
    />
  );
}

export default memo(ExpeditionScheduleWorkingPointsTableActionButtons);
